import React from 'react'

import * as yup from 'yup'
import { Formik } from 'formik'
import FormSection from '../../../../components/FormSection/FormSection'
import FormInputsEn from './FormInputsEn'
import FormInputsSr from './FormInputsSr'
// import FormInputs from './FormInputs'
import FormWrapper from '../../../../components/FormWrapper/FormWrapper'

const AboutServicesForm = ({ initialValues, onSubmit, onDelete, language, isEditForm = false }) => {
    const payloadSchema = yup.object().shape({
        text: yup.string().required(),
        textEn: yup.string().required(),
    })

    const _aboutServicesForm = (props) => {
        return (
            <FormSection
                {...props}
                FormInputsEn={FormInputsEn}
                FormInputsSr={FormInputsSr}
                // FormInputs={FormInputs}
                isEditForm={isEditForm}
                onDelete={onDelete}
            />
        )
    }

    return (
        <FormWrapper>
            <Formik
                initialValues={initialValues}
                enableReinitialize
                validationSchema={payloadSchema}
                onSubmit={onSubmit}
            >
                {_aboutServicesForm}
            </Formik>
        </FormWrapper>
    )
}

export default AboutServicesForm
